import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowupFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.719 14.5a.7.7 0 0 1-.521-.199.64.64 0 0 1-.198-.463q0-.067.223-.46l5.014-4.575a1.2 1.2 0 0 1 .357-.23A1.1 1.1 0 0 1 12 8.5a1.1 1.1 0 0 1 .406.073q.185.072.357.23l5.014 4.575q.105.094.163.211.06.117.06.25a.63.63 0 0 1-.198.464.7.7 0 0 1-.521.197z"
  }));
}
var IcArrowupFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowupFill));

export { IcArrowupFill as I };
